import { LoadingArea } from '@consigli/facade';
import { useProjectId, useBuildingPackageId, useBuildingPackageFiles } from '@consigli/hooks';
import { convertFileToDocument } from '@consigli/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CardBasedFileDisplay, INPUT_SECTIONS } from '@/components/card-based-file-display';
import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { WorkspaceProvider } from '@/layouts/workspace-layout/use-workspace-context';
import { WorkspaceLayout } from '@/layouts/workspace-layout/workspace-layout';

export const BuildingPackageInputPage: FC = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();

  const { t } = useTranslation();

  const { files, isLoading, isFetching } = useBuildingPackageFiles({
    projectId,
    buildingPackageId: buildingPackageId,
    page: 'all',
  });

  return (
    <>
      <Breadcrumb label={t('optimization-tabs.input')} />
      <WorkspaceProvider>
        <WorkspaceLayout>
          {isLoading ? (
            <LoadingArea title={t('document-list.loading')} />
          ) : files.length > 0 ? (
            <div className="flex">
              <CardBasedFileDisplay
                files={files.map((file) => convertFileToDocument(file))}
                isFetching={isFetching}
                isPublished={true}
                sections={INPUT_SECTIONS}
              />
            </div>
          ) : (
            <div className="flex justify-center items-center w-full h-full text-[24px]">
              {t('document-list.no-documents')}
            </div>
          )}
        </WorkspaceLayout>
      </WorkspaceProvider>
    </>
  );
};
